"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryPopupTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cbd7f2888{font-size:1.25rem;font-weight:700;line-height:1.5rem;margin-bottom:1.25rem}.ce4a5591a{color:var(--color-flomni-blue-70)}.cf86a618f{color:var(--color-flomni-green-70)}.cdd1b48ae{color:var(--color-flomni-rose-70)}");
var styles = {
  root: 'cbd7f2888',
  '--view-usual': 'ce4a5591a',
  '--view-success': 'cf86a618f',
  '--view-warning': 'cdd1b48ae'
};

var PrimaryPopupTitle = function PrimaryPopupTitle(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, children);
};

exports.PrimaryPopupTitle = PrimaryPopupTitle;
var view = ['usual', 'success', 'warning'];
PrimaryPopupTitle.modes = {
  view: view
};
PrimaryPopupTitle.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryPopupTitle.defaultProps = {
  classes: {},
  view: 'usual'
};